'use client';

import { useEffect } from 'react';

export default function ScrollProvider({ children }) {
  useEffect(() => {

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);


    const handleSmoothScroll = (e) => {
      const target = e.target;


      if (target === document || target === document.documentElement) {
        return;
      }
    };

    document.addEventListener('scroll', handleSmoothScroll, true);


    const handleScroll = () => {
      const scrollY = window.scrollY;


      if (scrollY > 0) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }


      const parallaxElements = document.querySelectorAll('[data-parallax]');
      parallaxElements.forEach((element) => {
        const offset = element.getAttribute('data-parallax');
        element.style.transform = `translateY(${scrollY * offset}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      document.removeEventListener('scroll', handleSmoothScroll, true);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return <>{children}</>;
}
